import { Exclude, Expose, Type } from 'class-transformer';
import { AccountType, PlatformAccountDTO } from './platform-account.dto';
import { UserDTO } from './user.dto';
import { WorkspaceMemberDTO } from './workspace-member.dto';
import { WorkspaceOwnerDTO } from './workspace-owner.dto';

@Exclude()
export class WorkspaceDTO {
  @Expose()
  id: number;

  @Expose()
  name: string;

  @Expose()
  pic: string;

  @Expose()
  @Type(() => PlatformAccountDTO)
  platformAccounts: PlatformAccountDTO[];

  @Expose()
  isOwner: boolean;

  @Expose()
  isActive: boolean;

  @Expose()
  workspaceMembers: WorkspaceMemberDTO[];

  @Expose()
  user: UserDTO;

  @Expose()
  owner: WorkspaceOwnerDTO;

  get tiktokPlatformAccount(): PlatformAccountDTO {
    return this.platformAccounts ? this.platformAccounts.find((pa) => pa.type === AccountType.TIKTOK) : null;
  }

  // DEPRECATED
  get activePlatformAccount(): PlatformAccountDTO {
    return this.platformAccounts ? this.platformAccounts.find((pa) => pa.isActive) : null;
  }
}
